import { DataGrid, DocumentRow, NoDocumentPlaceholder, TableSkeleton } from '@components/common';
import { SUPPLIER_GRADE_DOCUMENT_TYPE } from '@helpers/constants';
import { useMemo } from 'react';
import { CellProps } from 'react-table';
import AddProduct from '../add-product';
import { Button, Typography } from '@components/base';
import css from './index.module.scss';
import { IDocumentTabState } from '../..';
import { useNavigate } from 'react-router-dom';

interface RowGridType {
  product_name: object;
  product_grade: string;
  proofs: object;
  document_object: object;
}

interface ProductListPropsType {
  setDocumentTabState: React.Dispatch<React.SetStateAction<IDocumentTabState>>;
  getProductList: () => Promise<void>;
  documentTabState: IDocumentTabState;
}

const ProductList = (props: ProductListPropsType) => {
  const { setDocumentTabState, getProductList, documentTabState } = props;
  const { isLoading, openAddProductModal, productList } = documentTabState;

  const navigate = useNavigate();

  const [documentColumn, documentData] = useMemo(() => {
    const column: Array<any> = [
      {
        Header: 'Product Name',
        accessor: 'product_name',
        Cell: (props: CellProps<any>) => {
          const { value } = props;
          const documentType = `${value?.product_name?.product_name}`;
          const productId = value?.product_name?.product_id;
          if (documentType)
            return (
              <div
                className={css.documentNameWrapper}
                onClick={() => {
                  navigate(`/product/${productId}`);
                }}>
                <DocumentRow.Title
                  title={documentType}
                  documentAvailable={value?.document_object}
                />
              </div>
            );
          return null;
        }
      },
      {
        Header: 'Product Grade',
        accessor: 'product_grade'
      }
    ];

    let data: any[] = [];
    productList.forEach((prod: any) => {
      if (prod?.documents?.length) {
        prod.documents = SUPPLIER_GRADE_DOCUMENT_TYPE.map((item: any) => {
          const availableDoc = prod.documents.find((p: any) => p.document_type === item.value);
          return {
            document_type: item.value,
            product_name: prod,
            grade_name: prod.grade_name,
            document_object: availableDoc?.document_type,
            supplier_product_grade_id: prod.supplier_product_grade_id,
            ...availableDoc
          };
        });
      } else {
        prod.documents = SUPPLIER_GRADE_DOCUMENT_TYPE.map((item: any) => {
          return {
            product_name: prod,
            grade_name: prod.grade_name,
            document_object: null,
            document_type: item.value,
            supplier_product_grade_id: prod.supplier_product_grade_id
          };
        });
      }

      data = data.concat(prod.documents);
    });
    const row: Array<RowGridType> = data?.map((prod: any) => ({
      product_name: prod,
      product_grade: prod.grade_name,
      proofs: prod,
      document_object: prod
    }));

    return [column, row];
  }, [productList]);

  return (
    <div className={css.mainWrapper}>
      <div className={css.header}>
        <Typography variant="h4">Product List</Typography>
        <Button
          onClick={() =>
            setDocumentTabState((prevState: IDocumentTabState) => ({
              ...prevState,
              openAddProductModal: true
            }))
          }>
          Add Product
        </Button>
      </div>
      {isLoading ? (
        <TableSkeleton colsNum={2} />
      ) : productList.length ? (
        <DataGrid columns={documentColumn} data={documentData} />
      ) : (
        !isLoading && (
          <NoDocumentPlaceholder
            title="No products added yet"
            supportingText="When a products are added by you, they will show up here."
            buttonText="Add Product"
            onClick={() =>
              setDocumentTabState((prevState: IDocumentTabState) => ({
                ...prevState,
                openAddProductModal: true
              }))
            }
          />
        )
      )}

      {openAddProductModal && (
        <AddProduct
          open={openAddProductModal}
          onClose={() =>
            setDocumentTabState((prevState: IDocumentTabState) => ({
              ...prevState,
              openAddProductModal: false
            }))
          }
          getProductListOfSupplier={getProductList}
        />
      )}
    </div>
  );
};

export default ProductList;
